import { useEffect, useState } from "react";
import { useSupabase } from "@/components/providers/SystemProvider";
import { useIdentity } from "./useIdentity";

export type DoctorStatus = {
  loading: boolean;
  error: string | null;
  hasProfile: boolean;
  prescribingEnabled: boolean;
};

export function useDoctorStatus(): DoctorStatus {
  const supabase = useSupabase();
  const identity = useIdentity();
  const [state, setState] = useState<DoctorStatus>({
    loading: true,
    error: null,
    hasProfile: false,
    prescribingEnabled: false,
  });

  useEffect(() => {
    let cancelled = false;
    async function load() {
      // Wait for identity to be ready
      if (identity.status === 'loading') {
        return;
      }
      
      if (!identity.user?.id) {
        setState({ loading: false, error: null, hasProfile: false, prescribingEnabled: false });
        return;
      }
      
      setState((s) => ({ ...s, loading: true }));
      try {
        
        const { data, error } = await supabase.client
          .from("doctor_profiles")
          .select("id, prescribing_enabled, verified_at, suspended_at")
          .eq("auth_user_id", identity.user.id)
          .maybeSingle();
          
        if (cancelled) return;
        if (error) throw error;
        
        
        const hasProfile = !!data;
        const prescribingEnabled = !!(data?.prescribing_enabled && data?.verified_at && !data?.suspended_at);
        
        
        setState({
          loading: false,
          error: null,
          hasProfile,
          prescribingEnabled,
        });
      } catch (e: any) {
        if (cancelled) return;
        setState({ loading: false, error: e.message || String(e), hasProfile: false, prescribingEnabled: false });
      }
    }
    load();
    return () => { cancelled = true; };
  }, [identity.status, identity.user?.id, supabase.client]);

  return state;
}


